
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homepagelayout",
      function () {
        return require("private-next-pages/homepagelayout/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homepagelayout"])
      });
    }
  